<script>
import STable from '@/components/Table/index'
import {
  loadWorkLogList,
  createWorkLog,
  updateWorkLog,
  deleteWorkLog,
  exportWorkLogList,
  loadPermissionList
} from '@/api/data'
import { getI18nLanguage } from '@/locales'
import moment from 'moment'

export default {
  name: 'WorkLog',
  components: {
    STable
  },
  data () {
    return {
      locale: {
        emptyText: this.$t('table.emptyText')
      },
      col: {
        md: 12,
        lg: 8,
        xl: 8
      },
      queryParam: {
        name: '',
        qTime: []
      },
      drivers: [],
      // 表头
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          align: 'center',
          width: 70
        },
        {
          title: this.$t('worklog.field.name'),
          dataIndex: 'name',
          align: 'center',
          width: 120
        },
        {
          title: this.$t('worklog.field.plate'),
          dataIndex: 'plate_number',
          align: 'center',
          width: 120
        },
        {
          title: this.$t('worklog.field.work_start'),
          dataIndex: 'work_start_time',
          align: 'center',
          width: 150
        },
        {
          title: this.$t('worklog.field.work_end'),
          dataIndex: 'work_end_time',
          align: 'center',
          width: 150
        },
        {
          title: this.$t('worklog.field.work_location'),
          dataIndex: 'work_location',
          width: 160,
          ellipsis: true
        },
        {
          title: this.$t('worklog.field.rest_time'),
          dataIndex: 'rest_time',
          align: 'center',
          width: 110
        },
        {
          title: this.$t('worklog.field.rest_location'),
          dataIndex: 'rest_location',
          width: 140,
          ellipsis: true
        },
        {
          title: this.$t('worklog.field.distance'),
          dataIndex: 'distance',
          align: 'center',
          width: 110
        },
        {
          title: this.$t('worklog.field.waypoints'),
          dataIndex: 'waypoints',
          width: 180,
          ellipsis: true
        },
        {
          title: this.$t('worklog.field.action'),
          dataIndex: 'action',
          align: 'center',
          width: 120,
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        const params = {
          pageNo: parameter.pageNo,
          pageSize: parameter.pageSize,
          name: this.queryParam.name
        }
        if (this.queryParam.qTime && this.queryParam.qTime.length === 2) {
          params.start_time = this.queryParam.qTime[0].format('YYYY-MM-DD') + ' 00:00:00'
          params.end_time = this.queryParam.qTime[1].format('YYYY-MM-DD') + ' 23:59:59'
        }
        return loadWorkLogList(params).then(res => {
          return res.result
        })
      },
      modalVisible: false,
      modalLoading: false,
      editingRecord: null,
      form: this.$form.createForm(this)
    }
  },
  created () {
    this.loadDrivers()
  },
  methods: {
    getErrorMessage (msg) {
      if (typeof msg === 'string') {
        return msg
      }
      const lang = getI18nLanguage()
      const langKey = lang.replace('-', '').toLowerCase()
      if (langKey.includes('zh')) {
        return msg['zh'] || msg['zh-CN'] || msg['en'] || msg['en-US'] || ''
      } else if (langKey.includes('ja')) {
        return msg['ja'] || msg['ja-JP'] || msg['en'] || msg['en-US'] || ''
      } else {
        return msg['en'] || msg['en-US'] || msg['zh'] || ''
      }
    },
    loadDrivers () {
      loadPermissionList({
        type: 'all',
        pageNo: 1,
        pageSize: 1000
      }).then(res => {
        const data = (res.result && res.result.data) || []
        this.drivers = data.map(u => {
          const name = u.name || ''
          const account = u.account || ''
          return {
            value: u.user_id,
            label: account ? `${name}(${account})` : name
          }
        })
      })
    },
    handleSearch () {
      this.$refs.table.refresh(true)
    },
    handleReset () {
      this.queryParam.name = ''
      this.queryParam.qTime = []
      this.$refs.table.refresh(true)
    },
    openCreate () {
      this.editingRecord = null
      this.modalVisible = true
      this.$nextTick(() => {
        this.form.resetFields()
      })
    },
    openEdit (record) {
      this.editingRecord = record
      this.modalVisible = true
      this.$nextTick(() => {
        this.form.resetFields()
        this.form.setFieldsValue({
          user_id: record.user_id,
          plate_number: record.plate_number,
          work_start_time: record.work_start_time ? moment(record.work_start_time, 'YYYY-MM-DD HH:mm') : undefined,
          work_end_time: record.work_end_time ? moment(record.work_end_time, 'YYYY-MM-DD HH:mm') : undefined,
          work_location: record.work_location,
          rest_time: record.rest_time,
          rest_location: record.rest_location,
          distance: record.distance,
          waypoints: record.waypoints
        })
      })
    },
    validateWorkEnd (rule, value, callback) {
      const start = this.form.getFieldValue('work_start_time')
      if (value && start && value.valueOf() < start.valueOf()) {
        callback(new Error(this.$t('worklog.form.work_end.early')))
      } else {
        callback()
      }
    },
    handleSave () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        if (err) {
          return
        }
        this.modalLoading = true
        const params = {
          user_id: values.user_id,
          plate_number: values.plate_number,
          work_start_time: values.work_start_time.format('YYYY-MM-DD HH:mm:ss'),
          work_end_time: values.work_end_time.format('YYYY-MM-DD HH:mm:ss'),
          work_location: values.work_location || '',
          rest_time: values.rest_time || '',
          rest_location: values.rest_location || '',
          distance: values.distance === undefined || values.distance === null ? '' : values.distance,
          waypoints: values.waypoints || ''
        }
        const req = this.editingRecord
          ? updateWorkLog(Object.assign({ id: this.editingRecord.id }, params))
          : createWorkLog(params)
        req.then(res => {
          if (res.code === 0) {
            this.$message.success(this.$t('worklog.message.save.success'))
            this.modalVisible = false
            this.$refs.table.refresh(this.editingRecord ? false : true)
          } else {
            this.$message.error(this.getErrorMessage(res.msg) || this.$t('worklog.message.save.fail'))
          }
        }).catch(() => {
          this.$message.error(this.$t('worklog.message.save.fail'))
        }).finally(() => {
          this.modalLoading = false
        })
      })
    },
    handleDelete (record) {
      const self = this
      this.$confirm({
        title: self.$t('worklog.delete.confirm.title'),
        content: self.$t('worklog.delete.confirm.content'),
        okText: self.$t('worklog.action.delete'),
        cancelText: self.$t('worklog.action.cancel'),
        onOk () {
          return deleteWorkLog({ id: record.id }).then(res => {
            if (res.code === 0) {
              self.$message.success(self.$t('worklog.message.delete.success'))
              self.$refs.table.refresh(false)
            } else {
              self.$message.error(self.getErrorMessage(res.msg) || self.$t('worklog.message.delete.fail'))
            }
          }).catch(() => {
            self.$message.error(self.$t('worklog.message.delete.fail'))
          })
        }
      })
    },
    handleExport () {
      const params = {
        name: this.queryParam.name,
        lang: getI18nLanguage(),
        fileName: this.$t('worklog.export.filename') + '.xlsx'
      }
      if (this.queryParam.qTime && this.queryParam.qTime.length === 2) {
        params.start_time = this.queryParam.qTime[0].format('YYYY-MM-DD') + ' 00:00:00'
        params.end_time = this.queryParam.qTime[1].format('YYYY-MM-DD') + ' 23:59:59'
      }
      const hide = this.$message.loading(this.$t('worklog.export.loading'), 0)
      exportWorkLogList(params).then(res => {
        this.saveResultAsExcel(res, params.fileName)
      }).catch(() => {
        this.$message.error(this.$t('worklog.export.fail'))
      }).finally(() => {
        hide()
      })
    }
  }
}
</script>

<template>
  <div class="worklog-page">
    <div class="filter-card">
      <div class="filter-card__body">
        <a-row :gutter="16">
          <a-col :lg="col.lg" :xxl="col.xxl" :xl="col.xl" :md="col.md">
            <div class="filter-item">
              <label class="filter-item__label">{{ $t('worklog.field.name') }}</label>
              <a-input class="filter-item__input" v-model="queryParam.name" allowClear @pressEnter="handleSearch" />
            </div>
          </a-col>
          <a-col :lg="col.lg" :xxl="col.xxl" :xl="col.xl" :md="col.md">
            <div class="filter-item">
              <label class="filter-item__label">{{ $t('worklog.filter.work_date') }}</label>
              <a-range-picker class="filter-item__input" v-model="queryParam.qTime" />
            </div>
          </a-col>
          <a-col :lg="col.lg" :xxl="col.xxl" :xl="col.xl" :md="col.md">
            <div class="filter-item filter-item--actions">
              <a-button type="primary" @click="handleSearch">{{ $t('worklog.action.search') }}</a-button>
              <a-button @click="handleReset">{{ $t('worklog.action.reset') }}</a-button>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>

    <div class="table-card">
      <div class="table-card__toolbar">
        <a-button type="primary" icon="plus" @click="openCreate">{{ $t('worklog.action.create') }}</a-button>
        <a-button icon="download" @click="handleExport">{{ $t('worklog.action.export') }}</a-button>
      </div>
      <s-table
        ref="table"
        :columns="columns"
        :data="loadData"
        :locale="locale"
        :scroll="{ x: 1600 }"
        size="small">
        <div slot="action" slot-scope="text, record" class="action-cell">
          <a-button type="link" @click="openEdit(record)">{{ $t('worklog.action.edit') }}</a-button>
          <span class="action-divider"></span>
          <a-button type="link" class="action-link--danger" @click="handleDelete(record)">{{ $t('worklog.action.delete') }}</a-button>
        </div>
      </s-table>
    </div>

    <!-- 添加/编辑作业日志 -->
    <a-modal
      v-model="modalVisible"
      :title="editingRecord ? $t('worklog.modal.edit.title') : $t('worklog.modal.create.title')"
      :confirm-loading="modalLoading"
      :mask-closable="false"
      :width="640"
      @ok="handleSave">
      <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
        <a-form-item :label="$t('worklog.field.driver')">
          <a-select
            v-decorator="['user_id', { rules: [{ required: true, message: $t('worklog.form.user_id.tip') }] }]"
            show-search
            option-filter-prop="children"
            :placeholder="$t('worklog.form.user_id.placeholder')">
            <a-select-option v-for="d in drivers" :key="d.value" :value="d.value">{{ d.label }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('worklog.field.plate')">
          <a-input
            v-decorator="['plate_number', { rules: [{ required: true, message: $t('worklog.form.plate.tip') }] }]"
            :placeholder="$t('worklog.form.plate.placeholder')"
            allow-clear />
        </a-form-item>
        <a-form-item :label="$t('worklog.field.work_start')">
          <a-date-picker
            v-decorator="['work_start_time', { rules: [{ required: true, message: $t('worklog.form.work_start.tip') }] }]"
            show-time
            format="YYYY-MM-DD HH:mm"
            style="width: 100%"
            :placeholder="$t('worklog.form.work_start.placeholder')" />
        </a-form-item>
        <a-form-item :label="$t('worklog.field.work_end')">
          <a-date-picker
            v-decorator="['work_end_time', { rules: [{ required: true, message: $t('worklog.form.work_end.tip') }, { validator: validateWorkEnd }] }]"
            show-time
            format="YYYY-MM-DD HH:mm"
            style="width: 100%"
            :placeholder="$t('worklog.form.work_end.placeholder')" />
        </a-form-item>
        <a-form-item :label="$t('worklog.field.work_location')">
          <a-input
            v-decorator="['work_location']"
            :placeholder="$t('worklog.form.work_location.placeholder')"
            allow-clear />
        </a-form-item>
        <a-form-item :label="$t('worklog.field.rest_time')">
          <a-input
            v-decorator="['rest_time']"
            :placeholder="$t('worklog.form.rest_time.placeholder')"
            allow-clear />
        </a-form-item>
        <a-form-item :label="$t('worklog.field.rest_location')">
          <a-input
            v-decorator="['rest_location']"
            :placeholder="$t('worklog.form.rest_location.placeholder')"
            allow-clear />
        </a-form-item>
        <a-form-item :label="$t('worklog.field.distance')">
          <a-input-number
            v-decorator="['distance']"
            :min="0"
            :step="0.1"
            style="width: 100%"
            :placeholder="$t('worklog.form.distance.placeholder')" />
        </a-form-item>
        <a-form-item :label="$t('worklog.field.waypoints')">
          <a-textarea
            v-decorator="['waypoints']"
            :placeholder="$t('worklog.form.waypoints.placeholder')"
            :auto-size="{ minRows: 2, maxRows: 6 }" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<style scoped lang="less">
// 筛选条 + 数据卡的骨架（配色、圆角、投影、标签堆叠、工具条、操作列、卡片节奏）
// 十个列表页共用一份，见 assets/list-page.less
@import '../../assets/list-page.less';
</style>
